<template>
    <div v-cloak>
        <div class="container">
            <div v-if="hasPermission">
                <kyc-report v-if="!!model" :model="model"></kyc-report>
                <p v-else class="alert warning">
                    {{translate('no_data')}}
                </p>
            </div>
            <div v-else>
                <no-access :sub-page="detailStore.SubPage.KYC"></no-access>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import {defineComponent} from 'vue';
import {useDetailStore} from "../store";
import {KycModel, SubPage} from "../types";
import KycReport from './kyc/report.vue';
import NoAccess from "./no-access.vue";
import {Feature} from "../../../types/dto/Feature";

export default defineComponent({
    name: "kyc",
    components: {
        NoAccess,
        KycReport
    },
    data() {
        return {
            detailStore: useDetailStore()
        }
    },
    computed: {
        hasPermission(): boolean {
            return this.detailStore.canSeePaidComponents && this.detailStore.permissions[Feature.KYC];
        },
        model(): KycModel | null {
            return this.detailStore.pageModel[SubPage.KYC];
        }
    }
});
</script>

